import { handleActions } from 'redux-actions';
import { SET_AUDIENCES_ORDER_BY } from './actions';

const initialState = {
  audiencesOrderBy: {
    orderDir: 'desc',
    keyName: 'updatedAt',
  },
}

export const setAudiencesOrderBy = (state, { payload }) => {
  const { audiencesOrderBy } = payload;

  return {
    ...state,
    audiencesOrderBy,
  };
};

const mappedReducers = {
  [SET_AUDIENCES_ORDER_BY]: setAudiencesOrderBy,
}

const audiencesTableState = handleActions(mappedReducers, initialState);

export default audiencesTableState;
